module.exports = __webpack_public_path__ + "img/diao_guan_ji-icon1.641f0c96.png";